<script lang="ts">
import { defineComponent, inject, reactive } from 'vue';
import { useRouter } from 'vue-router';

import Card from './Card.vue';
import InputPhone from './InputPhone.vue';
import CodeInput from './CodeInput.vue';
import MessageError from './MessageError.vue';
import ButtonSendCode from './ButtonSendCode.vue';
import ButtonSubmit from './ButtonSubmit.vue';
import emitter from '@/utils/events';
import AuthServiceInterface from '@/services/interfaces/AuthServiceInterface';
import { useAuthStore } from '@/stores/AuthStore';

export default defineComponent({
  name: 'LoginForm',
  components: {
    Card,
    InputPhone,
    CodeInput,
    MessageError,
    ButtonSubmit,
    ButtonSendCode,
  },
  computed: {
    submitButtonDisabled() {
      if (this.data.model.code.length < 5 && this.data.isLogin) return true;
      if (this.data.model.phone.length < 14) return true;
      return false;
    },
  },
  setup() {
    const authService = inject<AuthServiceInterface>('authService');
    const authStore = useAuthStore();
    const router = useRouter();

    const data = reactive({
      submitted: false,
      isLogin: false,
      messageError: '',
      model: {
        phone: '',
        code: '',
      },
    });

    const sendCode = () => {
      setTimeout(() => {
        authService
          ?.sendCode({ phone: data.model.phone })
          .then(() => {
            data.isLogin = true;
            data.messageError = '';
            emitter.emit('clear-codeInput', null);
          })
          .catch(error => {
            data.messageError = error.response.data.data.phone[0] || '';
          });
      }, 500);
    };

    async function submit() {
      data.submitted = true;

      if (data.isLogin) {
        return authService
          ?.login(data.model)
          .then(response => {
            localStorage.setItem('token', response.data.access_token);
            authStore.setUser(response.data.user);
            router.push({ name: 'home' });
          })
          .catch(error => {
            data.messageError = error.response.data.message;
          });
      }
      sendCode();
    }
    return { data, sendCode, submit };
  },
});
</script>

<template>
  <Card class="p-8 py-7 bg-white w-10/12">
    <form :class="[{ submitted: data.submitted }]" @submit.prevent="submit">
      <InputPhone
        v-model:phone="data.model.phone"
        v-if="data.isLogin === false"
      />

      <CodeInput v-model:code="data.model.code" v-else />

      <MessageError :message="data.messageError" />

      <div class="form-group mt-6">
        <ButtonSubmit
          :isLogin="data.isLogin"
          :isDisabled="submitButtonDisabled"
        />
        <ButtonSendCode :sendCode="sendCode" v-if="data.isLogin" />
      </div>
    </form>
  </Card>
</template>
